import { Link } from "react-router-dom";

/** A titled panel with an optional count and "see all" link. */
export const Panel = ({ title, count, headline, to, testid, children, footer }) => (
  <div className="panel p-5 min-w-0" data-testid={testid}>
    <div className="flex items-baseline justify-between gap-3">
      <div className="label-xs">{title}</div>
      {count !== undefined && (
        <span className="mono text-lg font-black tabular-nums" data-testid={`${testid}-count`}>{count}</span>
      )}
    </div>
    {headline && (
      <div className="text-sm font-bold mt-2" data-testid={`${testid}-headline`}>{headline}</div>
    )}
    <div className="mt-3">{children}</div>
    {to && (
      <Link to={to} className="inline-block mt-3 text-xs font-semibold text-[#0055FF] hover:underline"
        data-testid={`${testid}-link`}>{footer || "Open"} →</Link>
    )}
  </div>
);

/** Simple two-column list: label on the left, number on the right. */
export const MiniList = ({ rows, left, right, empty = "Nothing pending.", testid }) => {
  if (!rows?.length) return <div className="text-sm text-muted-foreground">{empty}</div>;
  return (
    <div className="space-y-1.5" data-testid={testid}>
      {rows.map((r, i) => (
        <div key={r.id || r.so_no || r.book_id || r.title || r.publisher || r.party_name || i}
          className="flex items-baseline justify-between gap-3 text-sm border-b border-border pb-1.5">
          <span className="truncate min-w-0">{left(r)}</span>
          <span className="mono text-xs font-bold shrink-0 tabular-nums">{right(r)}</span>
        </div>
      ))}
    </div>
  );
};

/** Placeholder for a metric the app does not record yet (payments / COD). */
export const NotTracked = ({ label, hint, testid }) => (
  <div className="panel p-5 border-dashed" data-testid={testid}>
    <div className="label-xs">{label}</div>
    <div className="mono text-lg font-bold mt-2 text-muted-foreground">Not tracked yet</div>
    <div className="text-xs text-muted-foreground mt-1.5">{hint}</div>
  </div>
);
